const actions = {
    FINANCING_DASHBOARD_READ_REQUEST: 'FINANCING_DASHBOARD_READ_REQUEST',
    FINANCING_DASHBOARD_READ_SUCCESS: 'FINANCING_DASHBOARD_READ_SUCCESS',
    FINANCING_DASHBOARD_READ_ERROR: 'FINANCING_DASHBOARD_READ_ERROR',

    FINANCING_SETTINGS_UPDATE_REQUEST: 'FINANCING_SETTINGS_UPDATE_REQUEST',
    FINANCING_SETTINGS_UPDATE_SUCCESS: 'FINANCING_SETTINGS_UPDATE_SUCCESS',
    FINANCING_SETTINGS_UPDATE_ERROR: 'FINANCING_SETTINGS_UPDATE_ERROR',

    readFinancingDashboard: () => ({
        type: actions.FINANCING_DASHBOARD_READ_REQUEST,
    }),

    updateFinancingSettings: request => ({
        type: actions.FINANCING_SETTINGS_UPDATE_REQUEST,
        request,
    }),
};
export default actions;
